import { render, staticRenderFns } from "./sendTextModal.vue?vue&type=template&id=08f60312&"
import script from "./sendTextModal.vue?vue&type=script&lang=js&"
export * from "./sendTextModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports